<template>
  <div>
    <el-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_SettleAccountsTo') + $t('CargoMsg.Cargo_Details')"
      width="900px"
      :close-on-click-modal="false"
    >
      <div>
        <el-row :gutter="10">
          <el-col :span="18">
            <el-form label-width="80px">
              <el-row>
                `      <el-form-item :label="$t('CargoMsg.Cargo_ContractRule')">
                  <el-select :value="currentContract.uuid" style="width: 183px" no="contractRuleUuid" @change="contractChange">
                    <el-option
                      v-for="(item,index) in contractList"
                      :key="index"
                      :label="item.ruleName + (item.contractNo ? ('【' + item.contractNo + '】') : '')"
                      :value="item.uuid"
                    />
                  </el-select>
                </el-form-item>`
              </el-row>
            </el-form>
            <el-form inline disabled label-width="80px">
              <el-form-item :label="$t('Partners.credit_dateType')">
                <el-select v-model="currentOnlyCreditInfo.remarks" style="width: 183px" no="1">
                  <el-option v-for="(item, index) in DATETYPE_TYPE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Partners.credit_settlementMethod')">
                <el-select v-model="cbType" style="width: 100px" no="2">
                  <el-option :label="$t('Partners.credit_monthlySettlement')" :value="-1" />
                  <el-option :label="$t('Partners.credit_space3')" :value="-2" />
                  <el-option :label="$t('Partners.credit_space4')" value="n" />
                  <el-option :label="$t('Partners.credit_space5')" :value="-3" />
                  <el-option :label="$t('Partners.dailySettlement')" :value="-4" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input-number v-if="cbType==='n'" v-model="currentOnlyCreditInfo.creditDateType" :controls="false" style="width: 100px;" no="3" />
                <el-checkbox v-if="isShowBlacklist" v-model="creditInfo.blacklist" :label="$t('Partners.credit_blacklist')" style="margin-left: 5px;" no="4" />
              </el-form-item>
              <br>
              <el-form-item :label="$t('Partners.credit_accountPeriod')">
                <el-input-number v-model="currentOnlyCreditInfo.creditDateLimited" :controls="false" style="width: 100px;" no="5" />
                <el-select v-model="currentOnlyCreditInfo.termUnit" style="width: 80px;margin-left: 3px;" no="6">
                  <el-option :label="$t('Partners.credit_day')" :value="0" />
                  <el-option :label="$t('Partners.credit_week')" :value="1" />
                  <el-option :label="$t('Partners.credit_month')" :value="2" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Partners.credit_limit')">
                <el-input-number v-model="currentOnlyCreditInfo.credit" :controls="false" style="width: 100px;" no="7" />
                <el-select v-model="currentOnlyCreditInfo.currency" style="width: 100px;margin-left: 3px;" no="8">
                  <el-option label="RMB" value="RMB" />
                  <el-option label="USD" value="USD" />
                </el-select>
              </el-form-item>
              <br>
              <el-form-item disabled :label="$t('Partners.credit_settlementType')" no="9">
                <el-radio v-model="settlementByBill" :label="true">{{ $t('Partners.credit_settlementByBill') }}</el-radio>
                <el-radio v-model="settlementNotByBill" :label="true">{{ $t('Partners.credit_settlementNotByBill') }}</el-radio>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form>
              <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                <el-input
                  v-model="newCreditInfo.remark"
                  type="textarea"
                  :rows="6"
                  placeholder=""
                  style="width: 100%;max-height: 400px"
                />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%;margin-bottom: 8px">
          <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_OverdueExpenses')" name="otherDocuments" style="width:100%;height: 100%">
            <el-form style="margin-top: 5px">
              <el-form-item>
                <span>{{ lbLine }}</span>
                <span style="margin: 0 5px">{{ lbSum }}</span>
                <el-button type="primary" style="display: inline;width: 20px" no="16" @click="onRefreshCharge">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
                <el-button type="primary" :disabled="!enableNegelect" style="display: inline;width: 20px" no="17" @click="onNeglect">{{ $t('CargoMsg.Cargo_Ignore') }}</el-button>
                <el-button type="primary" :disabled="!enableNegelectRollback" style="display: inline;width: 20px" no="18" @click="onNeglectRollback">{{ $t('CargoMsg.Cargo_CancelIgnore') }}</el-button>
              </el-form-item>
            </el-form>
            <div class="app-main-inner-row row-grid" style="min-height:300px;">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="rowData"
                style="width: 100%;"
                no="19"
                @gridReady="params=>{ gridApi = params.api}"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_TempCredit')" name="tempCredit" style="width:100%;height: 100%">
            <el-form v-if="$checkPermission(['button_tabSettleAccountList_syncCredit'])" style="margin-top: 5px">
              <el-form-item>
                <el-button type="primary" no="syncCredit" @click="syncCreditHandler">{{ $t('SeaExport.Synchronization') }}</el-button>
                <el-tooltip :content="$t('CargoMsg.Cargo_SyncCreditTip')">
                  <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
                </el-tooltip>
              </el-form-item>
            </el-form>
            <div class="app-main-inner-row row-grid" style="min-height:300px;">
              <cargo-ag-grid
                :column-defs="tempCreditColumnDefs"
                :grid-options="tempCreditInfo.gridOptions"
                :row-data="tempCreditInfo.rowData"
                :show-side-bar="false"
                style="height:100%;min-height: 220px;"
                @rowDataChanged="rowDataChanged"
              />
            </div>
            <span>{{ $t('CargoMsg.Cargo_TempCreditNotice') }}</span>
          </el-tab-pane>
          <!--特批放号-->
          <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_SpecialApprovalIssuance')" name="specialApprovalIssuance" style="width:100%;height: 100%">
            <el-form style="margin-top: 5px">
              <el-form-item :label="$t('CargoMsg.Cargo_CurrentAvailableQuantity')">
                <el-input-number
                  v-model="partnerNumberAllocation.numberAllocationLimit"
                  no="numberAllocationLimit"
                  :precision="0"
                  :controls="false"
                  :min="0"
                  :max="999999999999"
                />
                <el-tooltip :content="$t('CargoMsg.Cargo_SpecialApprovalCreateBusiness')">
                  <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
                </el-tooltip>
              </el-form-item>
            </el-form>
            <div class="app-main-inner-row row-grid" style="min-height:300px;">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="partnerNumberAllocationRecordGrid.gridOptions"
                :column-defs="partnerNumberAllocationRecordGrid.columnDefs"
                :row-data="partnerNumberAllocationRecordGrid.rowData"
                style="width: 100%;"
                @gridReady="params=>{ partnerNumberAllocationRecordGrid.gridApi = params.api}"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
        <hr>
        <el-form inline :disabled="!canEditCredit" label-width="80px">
          <el-form-item :label="$t('Partners.credit_revenueAndExpenditureType')">
            <el-radio-group v-model="creditInfo.receivableDeposit" no="10">
              <el-radio :label="true">{{ $t('Partners.credit_collections') }}</el-radio>
              <el-radio :label="false">{{ $t('Partners.credit_payment') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('Partners.credit_depositAmount')">
            <el-input-number v-model="creditInfo.depositAmount" controls-position="right" :min="0" :max="9999999" style="width: 100px" no="11" />
          </el-form-item>
          <el-form-item :label="$t('Partners.credit_revenueAndExpenditureDate')">
            <el-date-picker v-model="creditInfo.depositDate" format="yyyy-MM-dd" style="width: 100px" no="12" />
          </el-form-item>
          <br>
          <el-form-item :label="$t('Partners.credit_revenueAndExpenditureMethod')">
            <el-select v-model="creditInfo.depositType" style="width: 134px;" no="13">
              <el-option :label="$t('Partners.credit_cash')" :value="0" />
              <el-option :label="$t('Partners.credit_space6')" :value="1" />
              <el-option :label="$t('Partners.credit_space7')" :value="2" />
              <el-option :label="$t('Partners.credit_space8')" :value="3" />
              <el-option :label="$t('Partners.credit_space9')" :value="4" />
              <el-option :label="$t('Partners.credit_space10')" :value="5" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.credit_depositCurrency')">
            <el-select v-model="creditInfo.depositCurrency" style="width: 100px;" no="14">
              <el-option label="RMB" value="RMB" />
              <el-option label="USD" value="USD" />
              <el-option label="HKD" value="HKD" />
            </el-select>
          </el-form-item>
          <br>
          <el-form-item :label="$t('Partners.credit_additionalDescription')">
            <el-input v-model="creditInfo.creditRmarks" :disabled="!canEditCredit" type="textarea" rows="10" style="width: 700px" no="15" />
          </el-form-item>
        </el-form>
      </div>
      <!--<div>
        <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%">
          <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_OverdueExpenses')" name="otherDocuments" style="width:100%;height: 100%">
            <el-form style="margin-top: 5px">
              <el-form-item>
                <span>{{ lbLine }}</span>
                <span style="margin: 0 5px">{{ lbSum }}</span>
                <el-button type="primary" style="display: inline;width: 20px" no="16" @click="onRefreshCharge">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
                <el-button type="primary" :disabled="!enableNegelect" style="display: inline;width: 20px" no="17" @click="onNeglect">{{ $t('CargoMsg.Cargo_Ignore') }}</el-button>
                <el-button type="primary" :disabled="!enableNegelectRollback" style="display: inline;width: 20px" no="18" @click="onNeglectRollback">{{ $t('CargoMsg.Cargo_CancelIgnore') }}</el-button>
              </el-form-item>
            </el-form>
            <div class="app-main-inner-row row-grid" style="min-height:300px;">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="rowData"
                style="width: 100%;"
                no="19"
                @gridReady="params=>{ gridApi = params.api}"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>-->
      <div slot="footer" style="text-align: center;">
        <el-button no="confirm" type="primary" @click="saveEventHandler(false)">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="cancel" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
      :is-submit="true"
      @close="innerVisible = false;$emit('handleSaved')"
    />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as creditInfoApi from '@/api/partner/creditInfo'
import { getLoading } from '@/utils/utilBaseElement'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import { exportExcel, exportPdf } from '@/utils/tableDataExportUtils'
import { DocumentManage, repareNodeSort } from '@/utils/commonUtil'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroupHP'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor/index.vue'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import {
  getApprovingContractOrCompany,
  saveCreditInfoRemark,
  saveTempCreditInfo,
  saveTempCreditInfoChange,
  syncTempCreditInfo
} from '@/api/partner/creditInfo'
import { deepClone, getUuid } from '@/utils'
import { cache, cacheName } from '@/utils/cacheManager'
import { DATETYPE_TYPE } from '@/class/cargo/model/parameters/ContractConstants'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import {
  APPLICATION_DIMENSION_COMPANY, APPLICATION_DIMENSION_CONTRACT,
  TEMP_CREDIT
} from '@/class/cargo/model/parameters/WorkflowConstants'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import { workflowActionBatch } from '@/api/workflow'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ContractConstants from '@/class/cargo/model/parameters/ContractConstants'
import { queryNumberAllocationInfo, saveNumberAllocationLimit } from '@/api/company'
import { PartnerNumberAllocation } from '@/class/model/mdm/PartnerNumberAllocation'

export default {
  name: 'CreditControlSettingDialog',
  components: {
    batchSubmitOrApproveDialog
  },
  props: {
    visible: { type: Boolean, required: true },
    company: { type: Object, required: true },
    currentCredit: { type: Object, required: true }
  },
  data() {
    return {
      DATETYPE_TYPE,
      originNumberAllocationLimit: 0,
      partnerNumberAllocation: new PartnerNumberAllocation().fillDefaultValue().getData(), // 合作伙伴-放号
      partnerNumberAllocationRecordGrid: {
        gridOptions: {},
        gridApi: null,
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_OccupiedBusinessNumber'), field: 'jobNo', width: 100 },
          { headerName: this.$t('SeaExport.DateOfCreation2'), field: 'dateCreated', width: 180, colId: 'dateCreated',
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_Creator'), field: 'createdBy', colId: 'createdBy', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_RemainingAvailableQuantity'), field: 'remainingLimit', colId: 'remainingLimit', width: 200 }
        ],
        rowData: []
      },
      innerVisible: false,
      cbType: -1,
      isShowBlacklist: false,
      canEditCredit: false,
      activeTabName: 'otherDocuments',
      gridParams: {},
      documentManage: new DocumentManage(),
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        suppressContextMenu: false, // 右键列表弹出菜单
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        getContextMenuItems: (params) => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport') + this.$t('Sales.CurrentlySelected'),
              action: function() {
                self.handleExportSelectedToExcel(params)
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport') + this.$t('Sales.CurrentPage'),
              action: function() {
                self.handleCurPageExportToExcel(params)
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF') + this.$t('Sales.CurrentlySelected'),
              action: function() {
                self.handleExportSelectedToPdf(params)
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF') + this.$t('Sales.CurrentPage'),
              action: function() {
                self.handleCurPageExportToPdf(params)
              }
            }
          ]
        },
        onRowClicked: this.onSelect,
        // 勾选
        onSelectionChanged: (params) => {
          this.checkChargeList = this.gridOptions.api.getSelectedRows()
        }
      },
      deleteTempCreditInfoUuidList: [],
      tempCreditInfo: {
        gridOptions: {
          // 单击显示编辑
          singleClickEdit: true,
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridDateTimeEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor
          },
          onSortChanged: this.rowDataChanged
        },
        rowData: []
      },
      baseTempCreditInfo: {
        effectiveDate: '',
        expirationDate: '',
        credit: '',
        creditDateLimited: ''
      },
      columnDefs: [
        { headerName: '', headerCheckboxSelection: true, checkboxSelection: true, width: 55, sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false },
        { headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'j_jobNo', width: 100 },
        { headerName: this.$t('CargoMsg.Cargo_ChargeName'), field: 'c_chargeItemId', width: 100,
          cellRenderer: params => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
        },
        { headerName: this.$t('CargoMsg.Cargo_Amount'), field: 'c_amount', width: 100,
          cellRenderer: params => ColumnUtils.number2ColumnLabelFunc(params.value)
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'c_currency', width: 100 },
        { headerName: this.$t('CargoMsg.Cargo_Date'), field: 'date', width: 100,
          cellRenderer: params => ColumnUtils.dateColumnLabelFunc(params.value)
        },
        { headerName: this.$t('CargoMsg.Cargo_OverdueDays'), field: 'day', width: 100 },
        { headerName: this.$t('CargoMsg.Cargo_IgnoreP'), field: 'negelect', width: 100,
          cellRenderer: params => ColumnUtils.booleanColumnLabelFunc(params.value)
        },
        { headerName: this.$t('Billing.DueDate'), colId: 'dueDate', field: 'dueDate', width: 120,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          field: 'cargoSalesId',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          },
          width: 150
        }
      ],
      rowData: [],
      canEditTempCreditInfo: this.$checkPermission(['button_tabSettleAccountList_tempCreditEdit']),
      config: {},
      creditInfo: {
        creditDateType: 0,
        blacklist: false,
        remarks: '',
        creditDateLimited: 0,
        termUnit: 0,
        credit: 0,
        currency: '',
        receivableDeposit: false,
        depositCurrency: '',
        depositAmount: 0,
        depositDate: '',
        depositType: 0,
        creditRmarks: ''
      },
      lbLine: this.$t('CargoMsg.Cargo_Deadline'),
      lbSum: '',
      selectedRow: null,
      gridApi: null,
      checkChargeList: [],
      contractList: [],
      newCreditInfo: {
        uuid: '',
        remark: ''
      },
      currentContract: {},
      currentOnlyCreditInfo: {}, // 仅 信控信息
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      currencySet: new Set(),
      termUnitList: [
        { value: 0, name: this.$t('Partners.day') },
        { value: 1, name: this.$t('Partners.week') },
        { value: 2, name: this.$t('Partners.month') }
      ]
    }
  },
  computed: {
    settlementByBill() {
      return Number(this.currentOnlyCreditInfo.creditDateLimited) === 0 && this.cbType && this.cbType !== 'n'
    },
    settlementNotByBill() {
      return Number(this.currentOnlyCreditInfo.creditDateLimited) > 0 || (this.cbType && this.cbType === 'n')
    },
    priOperate() {
      return this.$checkPermission(['button_SMCreditControl_permitAE']) || this.$checkPermission(['button_SMCreditControl_permitAI']) || this.$checkPermission(['button_SMCreditControl_permitSE']) || this.$checkPermission(['button_SMCreditControl_permitSI'])
    },
    enableNegelect() {
      // 权限
      if (this.priOperate) {
        // 勾选优先
        if (this.checkChargeList && this.checkChargeList.length >= 1) {
          if (this.checkChargeList.length > 1) {
            return true
          } else {
            return !this.checkChargeList[0].negelect
          }
        } else {
          // 鼠标选中
          return this.selectedRow && !this.selectedRow.negelect
        }
      } else {
        return false
      }
    },

    enableNegelectRollback() {
      if (this.priOperate) {
        // 勾选优先
        if (this.checkChargeList && this.checkChargeList.length >= 1) {
          if (this.checkChargeList.length > 1) {
            return true
          } else {
            return this.checkChargeList[0].negelect
          }
        } else {
          // 鼠标选中
          return this.selectedRow && this.selectedRow.negelect
        }
      } else {
        return false
      }
    },
    tempCreditColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
          field: 'effectiveDate',
          colId: 'effectiveDate',
          width: 180,
          minWidth: 180,
          sortable: false,
          editable: this.canEditTempCreditInfo,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
          field: 'expirationDate',
          colId: 'expirationDate',
          width: 180,
          minWidth: 180,
          editable: this.canEditTempCreditInfo,
          sortable: false,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Partners.credit_limit'),
          field: 'credit',
          colId: 'credit',
          width: 80,
          minWidth: 80,
          editable: this.canEditTempCreditInfo,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Partners.CreditUnit'),
          field: 'currency',
          colId: 'currency',
          width: 80,
          minWidth: 80,
          editable: this.canEditTempCreditInfo,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currencySet],
              filterable: true,
              clearable: false,
              filterTagNames: ['code']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Partners.credit_accountPeriod'),
          field: 'creditDateLimited',
          colId: 'creditDateLimited',
          width: 80,
          minWidth: 80,
          editable: this.canEditTempCreditInfo,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Partners.creditDateUnit'),
          field: 'termUnit',
          colId: 'termUnit',
          sortable: true,
          width: 80,
          minWidth: 80,
          cellRenderer: (params) => {
            const termMap = this.termUnitList.find(item => item.value === params.value)
            if (termMap) {
              return termMap.name
            }
            return ''
          },
          editable: this.canEditTempCreditInfo,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'value',
              tagName: 'name',
              clearable: false,
              staticOptions: this.termUnitList
            }
          },
          comparator: (a, b) => {
            if (a === b) {
              return 0
            } else if (a < b) {
              return -1
            } else {
              return 1
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          hide: !this.canEditTempCreditInfo,
          width: 140,
          cellRenderer: params => {
            const onAdd = this.documentManage.getPath('onAdd')
            const onDel = this.documentManage.getPath('onDel')
            return `<div>
                       <a onclick="${onAdd}()" style="color:#1F75D5;font-size:25px;">+</a>
                       <a onclick="${onDel}('${params.data.uuid}')" style="color:#1F75D5;font-size:25px;">-</a>
                     </div>`
          }
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.reset()
      }
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onAdd', function() {
      context.onAdd()
    })
    this.documentManage.set('onDel', function(value) {
      context.onDel(value)
    })
  },
  methods: {
    showCreditInfo() {
      if (this.currentCredit == null) {
        this.creditInfo.depositType = 2
      }
      if (this.currentOnlyCreditInfo.creditDateType === -1 || this.currentOnlyCreditInfo.creditDateType === 0) {
        this.cbType = -1
      } else if (this.currentOnlyCreditInfo.creditDateType === -2) {
        this.cbType = -2
      } else if (this.currentOnlyCreditInfo.creditDateType === -3) {
        this.cbType = -3
      } else if (this.currentOnlyCreditInfo.creditDateType === -4) {
        this.cbType = -4
      } else if (this.currentOnlyCreditInfo.creditDateType > 0) {
        this.cbType = 'n'
      }
    },
    async init() {
      await cache.load(cacheName.CONFIG)
      this.config = cache.config
      // this.canEditTempCreditInfo = Number(this.config.get('editTempCreditInfo')) === 1
      // 初始化【合同规则】信息
      this.contractList = deepClone(this.company.contractList)
      this.newCreditInfo = deepClone(this.company.creditInfo)
      this.currentContract = this.contractList[0]
      Object.assign(this.creditInfo, this.currentCredit)
      if (this.company.normalRuleContactExist) {
        this.currentOnlyCreditInfo = this.currentContract
        this.currentOnlyCreditInfo.remarks = this.currentContract.dateType
        if (this.currentContract.tempCreditInfoList) {
          this.tempCreditInfo.rowData = this.currentContract.tempCreditInfoList
        }
      } else {
        this.currentOnlyCreditInfo = this.creditInfo
        this.deleteTempCreditInfoUuidList = []
        if (this.company.tempCreditInfoList) {
          this.tempCreditInfo.rowData = deepClone(this.company.tempCreditInfoList)
        }
      }
      if (!this.tempCreditInfo.rowData || this.tempCreditInfo.rowData.length === 0) {
        this.tempCreditInfo.rowData = []
        this.onAdd()
      }
      this.showCreditInfo()
      this.onRefreshCharge()
      this.initCurrencySet()
      // 查询放号额度及放号记录
      this.getNumberAllocationInfo()
    },
    // 查询放号额度及放号记录
    getNumberAllocationInfo() {
      const loading = getLoading()
      queryNumberAllocationInfo({ companyUuid: this.company.uuid }).then(res => {
        this.partnerNumberAllocation = res.data
        this.partnerNumberAllocationRecordGrid.rowData = res.data.records
        this.originNumberAllocationLimit = this.company.numberAllocationLimit
      }).finally(() => loading.close())
    },
    initCurrencySet() {
      this.creditUseMultipleCurrency = Number(this.config.get('creditUseMultipleCurrency')) === 1
      if (this.creditUseMultipleCurrency) {
        const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
        const priorityCurrencies = results.filter(currency =>
          currency.code === 'RMB' || currency.code === 'USD' || currency.code === 'EUR')
        const otherCurrencies = results.filter(currency =>
          currency.code !== 'RMB' && currency.code !== 'USD' && currency.code !== 'EUR')
        this.currencySet = new Set([...priorityCurrencies, ...otherCurrencies])
      } else {
        this.currencySet = new Set([{ code: 'RMB' }, { code: 'USD' }])
      }
    },
    reset() {
      this.creditInfo = {
        creditDateType: 0,
        blacklist: false,
        remarks: '',
        creditDateLimited: 0,
        termUnit: 0,
        credit: 0,
        currency: '',
        receivableDeposit: false,
        depositCurrency: '',
        depositAmount: 0,
        depositDate: '',
        depositType: 0,
        creditRmarks: ''
      }
      this.rowData = []
      this.tempCreditInfo.rowData = []
      this.deleteTempCreditInfoUuidList = []
      this.cbType = -1
    },
    onSelect(event) {
      if (event.data) {
        this.selectedRow = event.data
      }
    },
    onRefreshCharge() {
      if (this.currentOnlyCreditInfo && this.currentOnlyCreditInfo.uuid && this.currentOnlyCreditInfo.remarks && this.currentOnlyCreditInfo.remarks !== '') {
        const params = {}
        params.branchId = this.$store.getters.currentOfficeId
        params.accountId = this.company.cmpIdx
        params.expire = this.currentOnlyCreditInfo.creditDateLimited
        params.unit = this.currentOnlyCreditInfo.termUnit
        params.type = this.currentOnlyCreditInfo.creditDateType
        params.dateType = this.currentOnlyCreditInfo.remarks
        if (this.company.normalRuleContactExist) {
          params.contractUuid = this.currentOnlyCreditInfo.uuid
        }
        if (this.company.creditInfo) {
          this.newCreditInfo.remark = this.company.creditInfo.remark
        }
        const loading = getLoading()
        creditInfoApi.searchCreditOutCharge(params).then(resp => {
          this.rowData = resp.data.list
          this.lbLine = this.$t('CargoMsg.Cargo_Deadline') + ':' + resp.data.line.split(' ')[0]
          const cache = {}
          let tip = ''
          for (const o of this.rowData) {
            if (cache.hasOwnProperty(o.c_currency)) {
              cache[o.c_currency] += o.c_amount
            } else {
              cache[o.c_currency] = o.c_amount
            }
          }
          for (const cur in cache) {
            tip += cur + ':' + cache[cur].toFixed(2) + ' '
          }
          this.lbSum = tip
          this.refreshSelectedRow()
        }).finally(() => loading.close())
      } else {
        this.rowData = []
      }
    },
    onNeglect() {
      if (this.checkChargeList.length >= 1) {
        this.onNeglectList()
        return
      }
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        return
      }
      const data = node.data
      const his = {}
      his.action = 2
      his.companyUuid = this.company.uuid
      his.createdBy = this.$store.getters.userId
      his.jobUuid = ''
      his.reason = ''
      his.jobNo = data.j_jobNo
      const chargeItem = ChargeItem.getChargeItemById(data.c_chargeItemId)
      if (chargeItem) {
        his.reason += this.$store.getters.language === 'zh' ? chargeItem.zhName : chargeItem.enName
      }
      his.reason += ' ' + data.c_amount
      his.reason += ' ' + data.c_currency

      const p = {}
      p.chargeUuid = data.c_key
      const params = {}
      params.chargePardon = p
      params.creditHistory = his
      const loading = getLoading()
      creditInfoApi.neglect(params).then(resp => {
        this.onRefreshCharge()
        this.gridOptions.api.clearFocusedCell()
      }).finally(() => loading.close())
      this.$message.success(this.$t('Message.TheSelectedDataIsIgnoredSuccessfully'))
    },
    onNeglectRollback() {
      if (this.checkChargeList.length >= 1) {
        this.onNeglectRollbackList()
        return
      }
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        return
      }
      const data = node.data
      const his = {}
      his.action = 3
      his.companyUuid = this.company.uuid
      his.createdBy = this.$store.getters.userId
      his.jobUuid = ''
      his.reason = ''
      his.jobNo = data.j_jobNo
      const chargeItem = ChargeItem.getChargeItemById(data.c_chargeItemId)
      if (chargeItem) {
        his.reason += this.$store.getters.language === 'zh' ? chargeItem.zhName : chargeItem.enName
      }
      his.reason += ' ' + data.c_amount
      his.reason += ' ' + data.c_currency

      const params = {}
      params.chargeUuid = data.c_key
      params.creditHistory = his
      const loading = getLoading()
      creditInfoApi.neglectRollback(params).then(resp => {
        this.onRefreshCharge()
        this.gridOptions.api.clearFocusedCell()
      }).finally(() => loading.close())
      this.$message.success(this.$t('Message.SelectedDataHasBeenBatchProcessedSuccessfully'))
    },

    onNeglectList() {
      const selectedRows = this.checkChargeList
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord'))
        return
      }
      // 创建一个空数组来存储处理后的数据
      const processedDataList = []

      // 遍历selectedRows并处理每一行的数据
      selectedRows.forEach(data => {
        if (data.negelect === undefined || data.negelect === true) {
          return // 跳过当前迭代，继续处理下一个数据
        }
        const his = {}
        his.action = 2
        his.companyUuid = this.company.uuid
        his.createdBy = this.$store.getters.userId
        his.jobUuid = ''
        his.reason = ''
        his.jobNo = data.j_jobNo
        const chargeItem = ChargeItem.getChargeItemById(data.c_chargeItemId)
        if (chargeItem) {
          his.reason += this.$store.getters.language === 'zh' ? chargeItem.zhName : chargeItem.enName
        }
        his.reason += ' ' + data.c_amount
        his.reason += ' ' + data.c_currency

        const p = {}
        p.chargeUuid = data.c_key
        const params = {}
        params.chargePardon = p
        params.creditHistory = his
        processedDataList.push(params)
      })
      // 不为空 再进行接口调用
      if (processedDataList.length !== 0) {
        const loading = getLoading()
        creditInfoApi.neglectBatch(processedDataList).then(resp => {
          this.onRefreshCharge()
          this.checkChargeList = []
          this.gridOptions.api.clearFocusedCell()
        }).finally(() => loading.close())
        this.$message.success(this.$t('Message.TheSelectedDataIsIgnoredSuccessfully'))
      } else {
        this.$message.warning(this.$t('Message.ThereAreNoNegligibleCosts'))
      }
    },
    onNeglectRollbackList() {
      const selectedRows = this.checkChargeList
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord'))
        return
      }
      // 创建一个空数组来存储处理后的数据
      const processedDataList = []

      // 遍历selectedRows并处理每一行的数据
      selectedRows.forEach(data => {
        if (data.negelect === undefined || data.negelect === false) {
          return // 跳过当前迭代，继续处理下一个数据
        }
        const his = {}
        his.action = 3
        his.companyUuid = this.company.uuid
        his.createdBy = this.$store.getters.userId
        his.jobUuid = ''
        his.reason = ''
        his.jobNo = data.j_jobNo
        const chargeItem = ChargeItem.getChargeItemById(data.c_chargeItemId)
        if (chargeItem) {
          his.reason += this.$store.getters.language === 'zh' ? chargeItem.zhName : chargeItem.enName
        }
        his.reason += ' ' + data.c_amount
        his.reason += ' ' + data.c_currency

        const params = {}
        params.chargeUuid = data.c_key
        params.creditHistory = his
        processedDataList.push(params)
      })
      // 不为空 再进行接口调用
      if (processedDataList.length !== 0) {
        const loading = getLoading()
        creditInfoApi.neglectRollbackBatch(processedDataList).then(resp => {
          this.onRefreshCharge()
          this.checkChargeList = []
          this.gridOptions.api.clearFocusedCell()
        }).finally(() => loading.close())
        this.$message.success(this.$t('Message.SelectedDataHasBeenBatchProcessedSuccessfully'))
      } else {
        this.$message.warning(this.$t('Message.ThereAreNoFeesThatCanBeEliminated'))
      }
    },
    refreshSelectedRow() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (node && node.data) {
        const data = node.data
        this.selectedRow = this.rowData.find(row => row.uuid === data.uuid)
      } else {
        this.selectedRow = null
      }
    },

    // CARGO-34394，亚东：信控业务管理的超期费用需要导出来
    // 右击菜单列表-导出Excel(当前选择)
    handleExportSelectedToExcel(params) {
      const { api, columnApi } = params
      // 获取显示列
      const allDisplayedColumns = columnApi.getAllDisplayedColumns()
      // 获取选中行
      const rowsToDisplay = []
      api.forEachNode(node => {
        if (node.selected) {
          rowsToDisplay.push(node)
        }
      })
      repareNodeSort(rowsToDisplay)
      const rows = rowsToDisplay.map(item => item.data)
      if (rows.length === 0) {
        this.$message.error(this.$t('Message.NoDataIsCurrentlySelected'))
        return
      }
      this.loading = getLoading()
      setTimeout(() => {
        const fileName = this.getFileName()
        const { totalConfig } = this
        if (totalConfig) {
          totalConfig.forEach(item => {
            item.dataProvider = rows
            const charge = new ChargeCurrencyTotalGroup(item)
            charge.recalc()
          })
        }
        exportExcel(fileName, rows, allDisplayedColumns, true, totalConfig)
        this.loading.close()
      }, 100)
    },
    // 右击菜单列表-导出Excel(当前页)
    handleCurPageExportToExcel(params) {
      this.loading = getLoading()
      setTimeout(() => {
        const { api, columnApi } = params
        // 获取显示列
        const allDisplayedColumns = columnApi.getAllDisplayedColumns()
        // 获取当前显示行
        const rowsToDisplay = []
        api.forEachNode(node => {
          if (node.displayed) {
            rowsToDisplay.push(node)
          }
        })
        repareNodeSort(rowsToDisplay)
        const rows = rowsToDisplay.map(item => item.data)
        console.log('excel', rows)
        const fileName = this.getFileName()
        const { totalConfig } = this
        if (totalConfig) {
          totalConfig.forEach(item => {
            item.dataProvider = rows
            const charge = new ChargeCurrencyTotalGroup(item)
            charge.recalc()
          })
        }
        exportExcel(fileName, rows, allDisplayedColumns, true, totalConfig)
        this.loading.close()
      }, 100)
    },
    // 右击菜单列表-导出PDF(当前选择)
    handleExportSelectedToPdf(params) {
      const { api, columnApi } = params
      // 获取显示列
      const allDisplayedColumns = columnApi.getAllDisplayedColumns()
      // 获取选中行
      const rowsToDisplay = []
      api.forEachNode(node => {
        if (node.selected) {
          rowsToDisplay.push(node)
        }
      })
      repareNodeSort(rowsToDisplay)
      const rows = rowsToDisplay.map(item => item.data)
      if (rows.length === 0) {
        this.$message.error(this.$t('Message.NoDataIsCurrentlySelected'))
        return
      }
      this.loading = getLoading()
      setTimeout(() => {
        const fileName = this.getFileName()
        exportPdf(fileName, rows, allDisplayedColumns)
        this.loading.close()
      }, 100)
    },
    getFileName() {
      const date = new Date()
      const month = date.getMonth() + 1
      const hour = date.getHours()
      const min = date.getMinutes()
      const sec = date.getSeconds()
      return this.exportFileName || `R${month}${hour}${min}${sec}`
    },
    // 右击菜单列表-导出PDF(当前页)
    handleCurPageExportToPdf(params) {
      this.loading = getLoading()
      setTimeout(() => {
        const { api, columnApi } = params
        // 获取显示列
        const allDisplayedColumns = columnApi.getAllDisplayedColumns()
        const fileName = this.getFileName()
        // 获取当前显示行
        const rowsToDisplay = []
        api.forEachNode(node => {
          if (node.displayed) {
            rowsToDisplay.push(node)
          }
        })
        repareNodeSort(rowsToDisplay)
        const rows = rowsToDisplay.map(item => item.data)
        exportPdf(fileName, rows, allDisplayedColumns)
        this.loading.close()
      }, 100)
    },
    onAdd() {
      const newTempCreditInfo = { ...this.baseTempCreditInfo }
      if (this.company.normalRuleContactExist) {
        newTempCreditInfo.contractUuid = this.currentContract.uuid
      } else {
        newTempCreditInfo.companyUuid = this.company.uuid
      }
      newTempCreditInfo.modify = true
      newTempCreditInfo.currency = this.currentOnlyCreditInfo.currency
      newTempCreditInfo.termUnit = this.currentOnlyCreditInfo.termUnit
      newTempCreditInfo.uuid = 'temp_' + getUuid()
      this.tempCreditInfo.rowData.push(newTempCreditInfo)
    },
    onDel(uuid) {
      let delUuid = ''
      if (uuid !== null) {
        const delRow = this.tempCreditInfo.rowData.find(row => row.uuid === uuid)
        delUuid = delRow.uuid
        this.tempCreditInfo.rowData = this.tempCreditInfo.rowData.filter(row => row.uuid !== uuid)
      }
      if (this.tempCreditInfo.rowData.length === 0) {
        this.onAdd()
      }
      if (delUuid && !delUuid.startsWith('temp_')) {
        if (this.company.normalRuleContactExist) {
          if (this.currentContract.deleteTempCreditInfoUuidList) {
            this.currentContract.deleteTempCreditInfoUuidList.push(delUuid)
          } else {
            this.currentContract.deleteTempCreditInfoUuidList = [delUuid]
          }
        } else {
          this.deleteTempCreditInfoUuidList.push(delUuid)
        }
      }
    },
    rowDataChanged(params) {
      ColumnUtils.sortChanged(params, this.columnDefs, this.tempCreditInfo.rowData)
    },
    onCellChange(params) {
      const data = params.data
      data.modify = true
      const field = params.colDef.field
      switch (field) {
        case 'effectiveDate':
          data[field] += ' 00:00:00'
          if (data.expirationDate) {
            if (new Date(data.effectiveDate) > new Date(data.expirationDate)) {
              this.exchangeEffectiveDateAndExpirationDate(data)
            }
          }
          this.tempCreditInfo.gridOptions.api.refreshCells({ force: true })
          break
        case 'expirationDate':
          data[field] += ' 23:59:59'
          if (data.effectiveDate) {
            if (new Date(data.effectiveDate) > new Date(data.expirationDate)) {
              this.exchangeEffectiveDateAndExpirationDate(data)
            }
          }
          this.tempCreditInfo.gridOptions.api.refreshCells({ force: true })
          break
        default:
      }
    },
    async saveEventHandler(syncCredit) {
      let saveSuccess = false
      if (!this.partnerNumberAllocation.numberAllocationLimit) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CurrentAvailableNotEntered'))
        return
      }
      // 保存合作伙伴-放单额度
      if (this.originNumberAllocationLimit !== this.partnerNumberAllocation.numberAllocationLimit) {
        this.loading = getLoading()
        this.partnerNumberAllocation.records = []
        await saveNumberAllocationLimit(this.partnerNumberAllocation).then(res => {
          saveSuccess = true
        }).finally(() => {
          this.loading.close()
        })
      }
      if (this.newCreditInfo.remark) {
        const params = {
          remark: this.newCreditInfo.remark,
          uuid: this.newCreditInfo.uuid
        }
        this.loading = getLoading()
        await saveCreditInfoRemark(params).then(res => {
          saveSuccess = true
        }).finally(() => {
          this.loading.close()
        })
        this.$emit('handleSaved')
      }
      if (this.company.normalRuleContactExist) {
        this.currentContract.tempCreditInfoList = this.tempCreditInfo.rowData
        // 校验
        for (const contract of this.contractList) {
          let msg = ''
          msg = this.checkSaveTempCreditInfo(contract.tempCreditInfoList)
          if (!msg && !this.checkDateRanges(contract.tempCreditInfoList)) {
            msg = this.$t('CargoMsg.Cargo_TempCreditNotBeCross')
          }
          if (msg) {
            this.$message.warning(msg)
            return
          }
        }
        // 预处理
        let modify = false
        let finalContractList = []
        this.contractList.forEach(contract => {
          const finalData = []
          const noModifiedData = []
          let rowModify = false
          if (contract.tempCreditInfoList && contract.tempCreditInfoList.length > 0) {
            contract.tempCreditInfoList.forEach(row => {
              if (!row.credit &&
                !row.creditDateLimited &&
                !row.effectiveDate &&
                !row.expirationDate) {
                return
              }
              if (row.modify) {
                modify = true
                rowModify = true
                if (row.uuid.startsWith('temp_')) {
                  row.uuid = ''
                }
                finalData.push(row)
              } else {
                noModifiedData.push(row)
              }
            })
          }
          contract.modifiedTempCreditInfoList = finalData
          contract.noModifiedTempCreditInfoList = noModifiedData
          if (contract.deleteTempCreditInfoUuidList && contract.deleteTempCreditInfoUuidList.length > 0) {
            modify = true
            rowModify = true
          }
          if (rowModify) {
            finalContractList.push(contract)
          }
        })
        if (!modify) {
          if (syncCredit) {
            await this.toSyncTempCreditInfo()
          } else {
            if (saveSuccess) {
              this.$message.success(this.$t('CargoMsg.Cargo_Success'))
            }
            this.innerVisible = false
          }
          return
        }

        let failMsgData = []
        this.loading = getLoading()
        // 1、获取已经存在审批中【临时信控】的【合作伙伴/合同】
        await getApprovingContractOrCompany({ contractUuids: finalContractList.map(item => item.uuid).join(',') }).then(async res => {
          if (res.data && res.data.length > 0) {
            res.data.forEach(uuid => {
              failMsgData.push({ 'formNumber': finalContractList.find(item => item.uuid === uuid).contractNo, 'errorMsg': this.$t('CargoMsg.Cargo_BpmSubmitDuplicated') })
            })
            finalContractList = finalContractList.filter(item => res.data.indexOf(item.uuid) < 0)
          }
        }).finally(() => {
          this.loading.close()
        })
        if (!finalContractList || finalContractList.length === 0) {
          this.batchSubmitOrApproveDialog.visible = true
          this.batchSubmitOrApproveDialog.rowData = failMsgData
          return
        }

        // 2、是否 存在 【临时信控】相关的审批流
        this.loading = getLoading()
        if (await WorkflowUtil.isBpmEnabled({
          documentConfigId: TEMP_CREDIT.code,
          officeId: finalContractList[0].branchId
        }).finally(() => {
          this.loading.close()
        })) {
          // 点击确认之后往下执行
          await this.$confirm(this.$t('CargoMsg.Cargo_SubmitTempCreditTip'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            showCancelButton: true,
            type: 'warning'
          })
          this.loading = getLoading()
          try {
            // 3、保存【临时信控变更】
            const approvalForms = await saveTempCreditInfoChange({
              contractList: finalContractList,
              companyUuid: this.company.uuid
            }).then(res => res.data)
            // 4、发起【临时信控审批】
            const params = []
            for (const approvalForm of approvalForms) {
              const param = {
                documentConfigId: TEMP_CREDIT.code,
                docId: approvalForm.uuid,
                docNo: approvalForm.docNo,
                actionType: 7000,
                officeId: finalContractList[0].branchId,
                applicationDimension: APPLICATION_DIMENSION_CONTRACT.code
              }
              params.push(param)
            }

            await workflowActionBatch(params).then(res => {
              if ((!failMsgData || failMsgData.length === 0) && (!res.data || res.data.length === 0)) {
                this.$message.success(this.$t('SeaExport.Submission') + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
                this.innerVisible = false
                this.$emit('handleSaved')
              } else {
                this.batchSubmitOrApproveDialog.visible = true
                if (!res.data || res.data.length === 0) {
                  failMsgData = [...failMsgData, ...res.data]
                }
                this.batchSubmitOrApproveDialog.rowData = failMsgData
              }
            })
          } finally {
            this.loading.close()
          }
        } else {
          // 5、保存【临时信控】
          const params = {
            contractList: finalContractList,
            syncCredit: syncCredit,
            companyUuid: this.company.uuid
          }
          this.loading = getLoading()
          saveTempCreditInfo(params).then(res => {
            if (failMsgData && failMsgData.length > 0) {
              this.batchSubmitOrApproveDialog.visible = true
              this.batchSubmitOrApproveDialog.rowData = failMsgData
            } else {
              if (res && res.data > 0) {
                this.$message.success(this.$t('CargoMsg.Cargo_Success'))
              }
              this.innerVisible = false
              this.$emit('handleSaved')
            }
          }).finally(() => {
            this.loading.close()
          })
        }
        return
      }
      const finalData = []
      const noModifiedData = []
      this.tempCreditInfo.rowData.forEach(row => {
        if (!row.credit &&
          !row.creditDateLimited &&
          !row.effectiveDate &&
          !row.expirationDate) {
          return
        }
        if (row.modify) {
          if (row.uuid.startsWith('temp_')) {
            row.uuid = ''
          }
          finalData.push(row)
        } else {
          noModifiedData.push(row)
        }
      })

      const params = {
        tempCreditInfoList: finalData,
        deleteTempCreditInfoUuidList: this.deleteTempCreditInfoUuidList,
        creditInfoUuid: this.currentCredit.uuid,
        syncCredit: syncCredit,
        companyUuid: this.company.uuid
      }
      if (!(params.tempCreditInfoList && params.tempCreditInfoList.length > 0) && !(params.deleteTempCreditInfoUuidList && params.deleteTempCreditInfoUuidList.length > 0)) {
        if (syncCredit) {
          await this.toSyncTempCreditInfo()
        } else {
          if (saveSuccess) {
            this.$message.success(this.$t('CargoMsg.Cargo_Success'))
          }
          this.innerVisible = false
        }
        return
      }
      let msg = ''
      msg = this.checkSaveTempCreditInfo(params.tempCreditInfoList)
      if (!msg && !this.checkDateRanges(this.tempCreditInfo.rowData)) {
        msg = this.$t('CargoMsg.Cargo_TempCreditNotBeCross')
      }
      if (msg) {
        this.$message.warning(msg)
        return
      }
      const failMsgData = []
      this.loading = getLoading()
      // 1、获取已经存在审批中【临时信控】的【合作伙伴/合同】
      await getApprovingContractOrCompany({ companyUuid: this.company.uuid }).then(async res => {
        if (res.data && res.data.length > 0) {
          failMsgData.push({ 'formNumber': this.company.cnShortName, 'errorMsg': this.$t('CargoMsg.Cargo_BpmSubmitDuplicated') })
        }
      }).finally(() => {
        this.loading.close()
      })
      if (failMsgData && failMsgData.length > 0) {
        this.batchSubmitOrApproveDialog.visible = true
        this.batchSubmitOrApproveDialog.rowData = failMsgData
        return
      }

      this.loading = getLoading()
      // 2、是否 存在 【临时信控】相关的审批流
      if (await WorkflowUtil.isBpmEnabled({
        documentConfigId: TEMP_CREDIT.code,
        officeId: this.company.branchId
      }).finally(() => {
        this.loading.close()
      })) {
        // 点击确认之后往下执行
        await this.$confirm(this.$t('CargoMsg.Cargo_SubmitTempCreditTip'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          showCancelButton: true,
          type: 'warning'
        })

        this.loading = getLoading()
        try {
          // 3、保存【临时信控变更】
          const approvalForms = await saveTempCreditInfoChange({
            tempCreditInfoList: finalData,
            noModifiedTempCreditInfoList: noModifiedData,
            deleteTempCreditInfoUuidList: this.deleteTempCreditInfoUuidList,
            creditInfoUuid: this.currentCredit.uuid,
            companyUuid: this.company.uuid
          }).then(res => res.data)
          // 4、发起【临时信控审批】
          const params = []
          const param = {
            documentConfigId: TEMP_CREDIT.code,
            docId: approvalForms[0].uuid,
            docNo: this.company.cnShortName,
            actionType: 7000,
            officeId: this.company.branchId,
            applicationDimension: APPLICATION_DIMENSION_COMPANY.code
          }
          params.push(param)

          await workflowActionBatch(params).then(res => {
            if (!res.data || res.data.length === 0) {
              this.$message.success(this.$t('SeaExport.Submission') + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
              this.innerVisible = false
              this.$emit('handleSaved')
            } else {
              this.batchSubmitOrApproveDialog.visible = true
              this.batchSubmitOrApproveDialog.rowData = res.data
            }
          })
        } finally {
          this.loading.close()
        }
      } else {
        this.loading = getLoading()
        try {
          saveTempCreditInfo(params).then(res => {
            if (res && res.data > 0) {
              this.$message.success(this.$t('CargoMsg.Cargo_Success'))
            }
            this.innerVisible = false
            this.$emit('handleSaved')
          })
        } finally {
          this.loading.close()
        }
      }
    },
    checkSaveTempCreditInfo(tempCreditInfoList) {
      let msg = ''
      if (tempCreditInfoList && tempCreditInfoList.length > 0) {
        for (const info of tempCreditInfoList) {
          if (!info.credit &&
            !info.creditDateLimited &&
            !info.effectiveDate &&
            !info.expirationDate) {
            continue
          }
          if (!info.credit) {
            msg = this.$t('Partners.credit_limit') + this.$t('CargoMsg.Cargo_CanNotEmpty')
            break
          }
          if (!info.creditDateLimited) {
            msg = this.$t('Partners.credit_accountPeriod') + this.$t('CargoMsg.Cargo_CanNotEmpty')
            break
          }
          if (!info.effectiveDate) {
            msg = this.$t('CargoMsg.Cargo_EffectiveDate') + this.$t('CargoMsg.Cargo_CanNotEmpty')
            break
          }
          if (!info.expirationDate) {
            msg = this.$t('CargoMsg.Cargo_InvalidDate') + this.$t('CargoMsg.Cargo_CanNotEmpty')
            break
          }
        }
      }
      return msg
    },
    checkDateRanges(tempCreditInfoList) {
      if (!tempCreditInfoList || tempCreditInfoList.length === 0) {
        return true
      }
      // const tempCreditInfoList = this.tempCreditInfo.rowData
      tempCreditInfoList.sort((a, b) => new Date(a.effectiveDate) - new Date(b.effectiveDate))
      for (let i = 0; i < tempCreditInfoList.length - 1; i++) {
        const currentEnd = new Date(tempCreditInfoList[i].expirationDate)
        const nextStart = new Date(tempCreditInfoList[i + 1].effectiveDate)
        if (currentEnd >= nextStart) {
          return false
        }
      }
      return true
    },
    exchangeEffectiveDateAndExpirationDate(data) {
      const effectiveDateParts = data.effectiveDate.split(' ')
      const expirationDateParts = data.expirationDate.split(' ')

      let effectiveDateOnly = effectiveDateParts[0]
      let expirationDateOnly = expirationDateParts[0]

      const effectiveTimeOnly = effectiveDateParts[1]
      const expirationTimeOnly = expirationDateParts[1]

      const temp = effectiveDateOnly
      effectiveDateOnly = expirationDateOnly
      expirationDateOnly = temp

      data.effectiveDate = effectiveDateOnly + ' ' + effectiveTimeOnly
      data.expirationDate = expirationDateOnly + ' ' + expirationTimeOnly
    },
    contractChange(contractUuid) {
      this.currentContract.tempCreditInfoList = this.tempCreditInfo.rowData
      this.currentContract.deleteTempCreditInfoUuidList = this.deleteTempCreditInfoUuidList
      this.currentContract = this.contractList.filter(item => item.uuid === contractUuid)[0]
      this.currentOnlyCreditInfo = this.currentContract
      this.currentOnlyCreditInfo.remarks = this.currentContract.dateType
      this.tempCreditInfo.rowData = this.currentContract.tempCreditInfoList
      this.deleteTempCreditInfoUuidList = this.currentContract.deleteTempCreditInfoUuidList
      if (!this.tempCreditInfo.rowData || this.tempCreditInfo.rowData.length === 0) {
        this.tempCreditInfo.rowData = []
        this.onAdd()
      }
      this.showCreditInfo()
      this.onRefreshCharge()
    },
    // 同步
    syncCreditHandler() {
      this.saveEventHandler(true)
    },
    // 未做修改，就单独同步接口
    async toSyncTempCreditInfo() {
      this.loading = getLoading()
      // 是否 存在 【临时信控】相关的审批流
      if (await WorkflowUtil.isBpmEnabled({
        documentConfigId: TEMP_CREDIT.code,
        officeId: this.company.branchId
      }).finally(() => {
        this.loading.close()
      })) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SyncTempCreditTip'))
        this.innerVisible = false
      } else {
        this.loading = getLoading()
        try {
          const params = {
            syncCredit: true,
            companyUuid: this.company.uuid
          }
          syncTempCreditInfo(params).then(res => {
            this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
            this.innerVisible = false
          })
        } finally {
          this.loading.close()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
